import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GetUserInfoRes } from '../models';
import { GetMemberCoursesReq, GetMemberCoursesRes } from '../models/get-member-courses';

export interface CoursesReportApi {
  getUserInfo(userId: number): Observable<GetUserInfoRes>;
  getMemberCourses(params: GetMemberCoursesReq): Observable<GetMemberCoursesRes>;
}

export const COURSES_REPORT_API = new InjectionToken<CoursesReportApi>('COURSES_REPORT_API');
